import { render } from "./Home.vue?vue&type=template&id=3f460c69&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3f460c69&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3f460c69"

export default script